module.exports = __webpack_public_path__ + "img/9788901086354.0e1fa527.jpg";